module.exports = __webpack_public_path__ + "img/shuichang.d44aba22.jpeg";